import { render } from "./CambiarDemarcacionModal.vue?vue&type=template&id=3ee15bd0&ts=true"
import script from "./CambiarDemarcacionModal.vue?vue&type=script&lang=ts"
export * from "./CambiarDemarcacionModal.vue?vue&type=script&lang=ts"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__